import { useMutation } from "@tanstack/react-query";

import { apiPaths } from "@/config/paths";
import type { MutationConfig } from "@/lib/react-query";
import { authApi } from "@/lib/api-client";
import { AxiosResponse } from "axios";

type Send2FAInput = {
  email: string;
  method?: "email" | "phone";
};

type Send2FAResponse = {
  success: boolean;
};

const send2FA = ({ data }: { data: Send2FAInput }): Promise<AxiosResponse<Send2FAResponse>> => {
  return authApi.post<Send2FAInput, AxiosResponse<Send2FAResponse>>(apiPaths.auth.send2FA.getPath(), {
    type: data.method,
  });
};

type UseSend2FAOptions = {
  mutationConfig?: MutationConfig<typeof send2FA>;
};

export const useSend2FA = ({ mutationConfig }: UseSend2FAOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      onSuccess?.(data, ...args);
    },
    ...restConfig,
    mutationFn: send2FA,
  });
};
